
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.01","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1943"}},[_c('path',{attrs:{"data-name":"Rectangle 2671","fill":"none","d":"M.01 0h24v24h-24z"}}),_c('g',{attrs:{"data-name":"Group 1942"}},[_c('path',{attrs:{"data-name":"Path 1245","d":"M21 3h-2.5V1.5a1.5 1.5 0 10-3 0V3h-7V1.5a1.5 1.5 0 10-3 0V3H3a3.008 3.008 0 00-3 3v15a3.009 3.009 0 003 3h18a3.009 3.009 0 003-3V6a3.009 3.009 0 00-3-3z"}}),_c('path',{attrs:{"data-name":"Path 1246","d":"M22.01 9.963v10a2.007 2.007 0 01-2 2h-16a2.007 2.007 0 01-2-2v-10z","fill":"#f9a36c"}}),_c('path',{attrs:{"data-name":"Union 21","d":"M17 19.999a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm-6 0a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm-6 0a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm12-5a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm-6 0a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1zm-6 0a1 1 0 01-1-1v-1a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1z"}}),_c('path',{attrs:{"data-name":"Path 1247","d":"M2 8V6a1 1 0 011-1h18a1 1 0 011 1v2z","fill":"#f9a36c"}})])])])
          )
        }
      }
    